import { useState } from "react";
import { ChevronDown } from "lucide-react";

const FAQ = ({ faqs = [], settings = {} }) => {
  const [open, setOpen] = useState(0);
  if (!faqs.length) return null;
  return (
    <section className="bg-[#FAF6F0] py-16 md:py-24">
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <div className="text-center mb-10 md:mb-14">
          <div className="text-[#8B2323] text-xs md:text-sm tracking-[0.4em] uppercase mb-3">Seeker&apos;s Questions</div>
          <h2 className="font-serif text-4xl md:text-5xl tracking-tight text-[#2D2825]">{settings.faq_title || "Frequently Asked Questions"}</h2>
          <div className="h-[2px] w-16 bg-[#D4AF37] mt-6 mx-auto" />
        </div>
        <div className="space-y-3">
          {faqs.map((f, i) => (
            <div key={i} className="bg-white rounded-2xl border border-[rgba(45,40,37,0.08)] overflow-hidden">
              <button
                onClick={() => setOpen(open === i ? -1 : i)}
                data-cursor="button"
                data-testid={`faq-toggle-${i}`}
                className="w-full flex items-center justify-between text-left px-6 py-5 hover:bg-[#faf6f0] transition-colors"
              >
                <span className="font-serif text-base md:text-lg text-[#2D2825] pr-6">{f.q}</span>
                <ChevronDown className={`text-[#8B2323] transition-transform ${open === i ? "rotate-180" : ""}`} size={18} />
              </button>
              {open === i && (
                <div className="px-6 pb-5 text-sm text-[#5C544F] leading-relaxed">{f.a}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
